import React from 'react';

/**
 * The common page frame of the settings screens (Invoicing & accounting, Rompslomp): the same
 * `container-fluid > row > col-12` frame the Orders, Expenses and Tracking pages use, so the theme's page padding applies
 * and banners sit INSIDE the padded container (never edge to edge). `banners` render above the content.
 */
export default function SettingsPage({ title, subtitle, banners, className = '', children }) {
    return (
        <div className={`container-fluid settings-page ${className}`.trim()}>
            <div className="row">
                <div className="col-12">
                    {title && (
                        <div className="settings-page-header mb-3">
                            <h4 className="heading mb-1">{title}</h4>
                            {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
                        </div>
                    )}
                    {banners}
                    {children}
                </div>
            </div>
        </div>
    );
}
